import React, { useRef } from "react";
import { Histogram } from "@ant-design/charts";

const basic = {
	binField: "value",
	autoFit: true,
};

const stackField = "type";
const legend = {
	position: "top",
};

export default function HistogramChart(chartData = [], chartConfig = {}) {
	const config = {
		data: chartData,
		...basic,
		legend: legend,
		stackField: chartConfig.stackField ? stackField : false,
	};
	const ref = useRef();

	return <Histogram {...config} chartRef={ref} />;
}
